import { z } from "zod";
import { ColumnSchema, ViewSchema, ViewType } from "./views";

export enum FinancialDocumentColumn {
    UPLOAD_DATE = "uploadDate",
    NAME = "name",
    ENTITY = "entity",
    FINANCIAL_ACCOUNT = "financialAccount",
    ACTIONS = "actions",
    MATCHED_TRANSACTION = "matchedTransaction",
    UPLOADER = "uploader",
    DOCUMENT_CATEGORY = "documentCategory",
    COUNTERPARTY = "counterparty",
    PERIOD = "period",
    STATUS = "status",
}

export enum FinancialDocumentSortValue {
    UPLOAD_DATE_ASC = "UPLOAD_DATE_ASC",
    UPLOAD_DATE_DESC = "UPLOAD_DATE_DESC",
    NAME_ASC = "NAME_ASC",
    NAME_DESC = "NAME_DESC",
}

export const FinancialDocumentViewSchema = ViewSchema.extend({
    type: z.literal(ViewType.FINANCIAL_DOCUMENT),
    columns: z.array(
        ColumnSchema.extend({
            id: z.nativeEnum(FinancialDocumentColumn),
        }),
    ),
});

export type FinancialDocumentView = z.infer<typeof FinancialDocumentViewSchema>;
